type GridItemProps = {
  name: string;
  value?: string | number;
  unit?: string;
};

export const ClinicalGridItem = ({ name, value, unit }: GridItemProps) => {
  const label = unit ? `${name}, ${unit}` : name;

  return (
    <div>
      <div className="text-s-m text-base-20">{label}</div>
      <div className="text-l-sb text-base-5">{value ?? '-'}</div>
    </div>
  );
};
